var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "prelative" },
    [
      _c("preloader", {
        staticClass: "preloader",
        attrs: { display: _vm.loading }
      }),
      _vm._v(" "),
      !_vm.loading
        ? _c("div", { domProps: { innerHTML: _vm._s(_vm.html) } })
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }